/**
 * Локаль гостя для витрины каталога.
 *
 * Порядок: явный выбор пользователя (localStorage `hsc:locale`) →
 * язык браузера → 'ru' (Russian-first платформа). Бэкенд дополнительно
 * делает fallback на tenants.default_locale (proposal v2, раздел 3).
 */
const LOCALE_KEY = 'hsc:locale';
export type GuestLocale = 'ru' | 'en';

export function resolveGuestLocale(): GuestLocale {
  try {
    const stored = window.localStorage.getItem(LOCALE_KEY);
    if (stored === 'ru' || stored === 'en') return stored;
  } catch {
    /* приватный режим / SSR — игнорируем */
  }
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'ru';
  return nav.toLowerCase().startsWith('en') ? 'en' : 'ru';
}
